import Pagination from '../../components/base/Pagination';

export default () => {
    /**
     * Нажали на какую-либо кнопку в компоненте пагинации
     */
    $(document).on('click', '.js-pagination a', function(event) {
        event.preventDefault();

        /** @var string clickedButtonHref - Ссылка кликнутой кнопки */
        const clickedButtonHref = $(this).attr('href');
        if (!clickedButtonHref || clickedButtonHref == '') {
            return;
        }

        /** @var string mainPaginationBlock - Блок пагинации */
        const mainPaginationBlock = $(this).closest('.js-pagination');

        const pagination = new Pagination(mainPaginationBlock);

        /** @var string itemsList - Блок со списком */
        const itemsList = $(this).closest('.js-pagination-items');

        /** @var string ajaxLoadComponent - Компонент, к которому мы обращаемся через ajax */
        const ajaxLoadComponent = mainPaginationBlock.attr('data-ajax-load-component');

        /** @var int page - Страница, на которую надо переместить */
        const page = pagination.getParameterFromString(clickedButtonHref, 'p');

        pagination.changeParameterInUrl('p', page);
        const query = pagination.getQuery();

        $.ajax({
            url: `/api/internal/component/${ajaxLoadComponent}${query}`,
            method: 'get',
            data: {
                p: page,
            },
            success(response) {
                itemsList.fadeOut('fast');
                itemsList.html(response);
                itemsList.fadeIn('fast');
                $('html, body').animate({ scrollTop: 0 }, '300');
            },
        });
    });
};
